import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import avatar from "../../Assets/svg/avatar-img.svg";
import Input from "../modules/Input";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Avatars from "../modules/AvatarGroup";
import ModalComponent from "../modules/Modal";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addAlumniInfo, addMentorInfo } from "../Connect/redux/actions";
import GradientLoader from "../modules/Loader";
import { mbaColleges, engColleges } from "../modules/CollegeList";
import { useNavigate } from "react-router-dom";
import DropSelect from "../modules/AutoComplete";

function Connect() {
  const navigate = useNavigate();
  const [universities, setuniversities] = useState([]);
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "",
    countDown: " ",
    desc: "",
  });
  const [uploading, setUploading] = useState(false);

  const [concern, setConcern] = useState("");
  const [id, setId] = useState("");

  const scholars = useSelector((state) => state.connect.scholars);
  const [Link, setLink] = useState(
    window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "")
  );
  const tokenData = useSelector((state) => state.tokens.tokens);
  const dispatch = useDispatch();

  const [checkList, setCheckList] = useState({
    program: "",
    college: "",
    batch: "",
  });
  const takeRequest = () => {
    let item = scholars.filter((a) => a.applicationId === id)[0];

    return (
      <div className="feedback-content">
        <div className="mentor-info">
          <div className="image img-section">
            {/* <img src={avatar} alt="avatar" /> */}
            {item?.image && item?.imageExtension && (
              <img
                // className="image"
                src={
                  item?.image && item?.imageExtension
                    ? "data:image/" +
                      item?.imageExtension +
                      ";base64," +
                      item?.image
                    : null
                }
                alt="Preview"
                // style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          </div>
          <div
            className="mentor-text"
            style={{ marginLeft: "2%", justifyContent: "space-between" }}
          >
            <span className="set-title">{item?.name || item?.fullName}</span>
            <span className="md-desc" style={{ color: "#222222" }}>
              {item?.name || item?.fullName}
            </span>
          </div>
        </div>

        <div className="comment-field">
          <Input
            onChange={(e) => setConcern(e.replace(/[^a-zA-Z0-9. ]/g, ""))}
            placeholder={"Could you tell us a little more?"}
            multiline={true}
          />
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Cancel"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => checkRequest()}
            value={"Connect"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };
  const scholarContent = () => {
    return (
      <div className="feedback-content">
        <Avatars type="alumni" />
        <div className=" md-title ">
          Find more than 100+ Alumni members on the platform
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => navigate("/application/connect/alumni")}
            value={"Start Networking"}
            type={"contained"}
          />
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"I’ll check it out later"}
            type={"only-text"}
          />
        </div>
      </div>
    );
  };
  const startRequest = (id, item) => {
    //   if (Link.split("/")[2] === "alumni") {
    //     dispatch(addMentorInfo({type:'alumniProfile', value:[item]}));
    //     dispatch(addAlumniInfo('scholar'));

    //     navigate("/application/alumni/profile");
    //   } else {
    //   setId(id);
    //   setModalData({
    //     ...ModalData,
    //     type: "request",
    //     show: true,
    //     title: "Connection Request",
    //     desc: "",
    //   });
    // }
    dispatch(addMentorInfo({ type: "alumniProfile", value: [item] }));
    dispatch(addAlumniInfo("scholar"));
    if (Link.split("/")[2] === "alumni") {
      navigate("/application/alumni/profile");
    } else {
      // setId(newId);
      // setModalData({
      //   ...ModalData,
      //   type: "request",
      //   show: true,
      //   title: "Connection Request",
      //   desc: "",
      // });
      navigate("/application/connect/alumni-profile");
    }
  };
  const getAlumni = async () => {
    let data = {
      program: checkList.program,
      batch: checkList.batch,
      college: checkList.college,
    };
    try {
      const scholarData = await api.getAlumni(
        tokenData.token,
        false,
        tokenData.applicationData.id,
        data
      );

      if (scholarData.statusCode == 200) {
        dispatch(
          addMentorInfo({ type: "scholars", value: scholarData.data ?[...scholarData.data]:[] })
        );
      // } else {
      //   dispatch(addMentorInfo({ type: "scholars", value: [] }));
      }
      console.log("scholarData", scholarData);
    } catch (err) {
      console.log("err", err);
    }
  };
  const makeRequest = async () => {
    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let data = {
      senderApplicationId: tokenData.applicationData.id,
      receiverApplicationId: id,
      isReceiverAlumni: false,
      message: concern,
    };
    try {
      const request = await api.sendAlumniRequest(tokenData.token, data);
      console.log("users", request);
      return request;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const checkRequest = async () => {
    setUploading(true);
    try {
      const request = await makeRequest();
      console.log("users", request);
      setUploading(false);
      if (request.statusCode == 200) {
        setModalData({
          ...ModalData,
          type: "complete",
          title: (
            <div className="set-title">
              <div className="happy-icon">
                <img src={tick} alt="tick" />
              </div>
              Connection request sent!
            </div>
          ),
          desc: "Your contact details will be shared via email",
        });
      }
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      setUploading(false);

      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  useEffect(() => {
    getAlumni();
  }, [checkList]);
  useEffect(() => {
    let newCurrent = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    console.log("currentUrl2", newCurrent, newCurrent.split("/"));
    // const cleanedUrl = currentUrl.replace(/^http?:\/\/(www\.)?/, "");
    setLink(newCurrent);
  }, []);
  console.log("scholars", scholars, mbaColleges, engColleges);
  return (
    <div className="get-connect-page">
      <div className="scholar-top-text">
        <span className="md-title">Find Scholars based on</span>
        <Button
          onClickHandler={() =>
            setCheckList({
              program: "",
              college: "",
              batch: "",
            })
          }
          type={
            checkList.program !== "" ||
            checkList.college !== "" ||
            checkList.batch !== ""
              ? "only-text"
              : "only-text-grey"
          }
          value={"Clear all"}
        />
      </div>
      <div className="check-lists">
        <DropBtn
          title={"Program"}
          value={checkList.program}
          list={["MBA", "Engineering"]}
          onChange={(e) => setCheckList({ ...checkList, program: e })}
        />
        <DropSelect
          title={"College"}
          value={checkList.college}
          list={
            checkList.program === "MBA"
              ? [
                  ...new Set(
                    mbaColleges?.map(
                      (item) => item["Name of university/College"]
                    )
                  ),
                ]
              : [
                  ...new Set(
                    engColleges?.map(
                      (item) => item["Name of university/College"]
                    )
                  ),
                ]
          }
          onChange={(e) => setCheckList({ ...checkList, college: e })}
        />

        <DropBtn
          title={"Batch"}
          value={checkList.batch}
          list={
            checkList.program === "MBA"
              ? ["2021-2023", "2022-2024", "2023-2025", "2024-2026"]
              : ["2021-2025", "2022-2026", "2023-2027", "2024-2028"]
          }
          onChange={(e) => setCheckList({ ...checkList, batch: e })}
        />
      </div>
      <div className="scholar-cards">
        {scholars?.map((item, index) => {
          return (
            <div key={index} className="scholar-card">
              {/* <img src={avatar} alt="avatar" /> */}
              <div className="image img-section">
                {item?.image && item?.imageExtension && (
                  <img
                    // className="image"
                    src={
                      "data:image/" +
                      item?.imageExtension +
                      ";base64," +
                      item?.image
                    }
                    alt="Preview"
                    // style={{ maxWidth: "100%", height: "100%" }}
                  />
                )}
              </div>
              <span className="set-title">{item?.name || item?.fullName}</span>
              <span className="sub-option-text">{item?.college}</span>
              <span className="sub-option-text" style={{ color: "#787878" }}>
                {item?.batch}
              </span>
              {/* <span className="sub-option-text" style={{ color: "#787878" }}>
                Bengaluru, Karnataka
              </span> */}
              {/* {index % 2 === 0 ? (
                <Button
                  onClickHandler={() => {}}
                  value={"Request sent"}
                  type={"disabled-grey"}
                />
              ) : ( */}
              <Button
                onClickHandler={() => startRequest(item?.applicationId, item)}
                value={"Connect"}
                type={"outlined"}
              />
              {/* )} */}
            </div>
          );
        })}
      </div>
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={
            ModalData.type === "request"
              ? "mentor-list"
              : ModalData.type === "network"
              ? "mentor"
              : "complate-modal"
          }
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {/* {ModalData.type === "confirm" ? (
          ) :ModalData.type === "network" ? (
            scholarContent()
          ) : ( */}
          {/* <Button
              onClickHandler={() => setModalData({ ...ModalData, type:'network', title:'', desc:'' })}
              value={"Okay"}
              type={"contained"}
            /> */}
          {ModalData.type === "request" ? (
            takeRequest()
          ) : ModalData.type === "network" ? (
            scholarContent()
          ) : (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  show: false,
                  title: "",
                  //   show: false,
                  desc: "",
                })
              }
              value={"Okay"}
              type={"contained"}
            />
          )}

          {/* // )} */}
        </ModalComponent>
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default Connect;
